module.exports = __webpack_public_path__ + "assets/img/txt-message.c7787a07.png";